import { render, staticRenderFns } from "./PublicQuotationPages.vue?vue&type=template&id=6f9d5300&scoped=true&"
import script from "./PublicQuotationPages.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d5300",
  null
  
)

export default component.exports